import React from 'react';
import './livechatStyle.css';

export default function LiveChatPage(props) {


  return (
    <section className="col_flex_aro AVRsection" style={{position: 'relative'}}>
      <div className="row_flex_aro" id="pourquoiunlivechat" style={{marginTop: '40px'}}>
        <h2 className="lvH2Title">Pourquoi un LiveChat avec REACTjs</h2>
      </div>
      <div className={window.screen.width > 550 ? "row_flex_aro" : "col_flex_aro"}>
        <br></br><br></br>
        <div className="col_flex_aro reactLogoAnimate">
          <div>
            <svg height="150" width="150" viewBox="175.7 78 490.6 436.9" xmlns="http://www.w3.org/2000/svg">
              <g fill="#61dafb">
                <path d="m666.3 296.5c0-32.5-40.7-63.3-103.1-82.4 14.4-63.6 8-114.2-20.2-130.4-6.5-3.8-14.1-5.6-22.4-5.6v22.3c4.6 0 8.3.9 11.4 2.6 13.6 7.8 19.5 37.5 14.9 75.7-1.1 9.4-2.9 19.3-5.1 29.4-19.6-4.8-41-8.5-63.5-10.9-13.5-18.5-27.5-35.3-41.6-50 32.6-30.3 63.2-46.9 84-46.9v-22.3c-27.5 0-63.5 19.6-99.9 53.6-36.4-33.8-72.4-53.2-99.9-53.2v22.3c20.7 0 51.4 16.5 84 46.6-14 14.7-28 31.4-41.3 49.9-22.6 2.4-44 6.1-63.6 11-2.3-10-4-19.7-5.2-29-4.7-38.2 1.1-67.9 14.6-75.8 3-1.8 6.9-2.6 11.5-2.6v-22.3c-8.4 0-16 1.8-22.6 5.6-28.1 16.2-34.4 66.7-19.9 130.1-62.2 19.2-102.7 49.9-102.7 82.3 0 32.5 40.7 63.3 103.1 82.4-14.4 63.6-8 114.2 20.2 130.4 6.5 3.8 14.1 5.6 22.5 5.6 27.5 0 63.5-19.6 99.9-53.6 36.4 33.8 72.4 53.2 99.9 53.2 8.4 0 16-1.8 22.6-5.6 28.1-16.2 34.4-66.7 19.9-130.1 62-19.1 102.5-49.9 102.5-82.3zm-130.2-66.7c-3.7 12.9-8.3 26.2-13.5 39.5-4.1-8-8.4-16-13.1-24-4.6-8-9.5-15.8-14.4-23.4 14.2 2.1 27.9 4.7 41 7.9zm-45.8 106.5c-7.8 13.5-15.8 26.3-24.1 38.2-14.9 1.3-30 2-45.2 2-15.1 0-30.2-.7-45-1.9-8.3-11.9-16.4-24.6-24.2-38-7.6-13.1-14.5-26.4-20.8-39.8 6.2-13.4 13.2-26.8 20.7-39.9 7.8-13.5 15.8-26.3 24.1-38.2 14.9-1.3 30-2 45.2-2 15.1 0 30.2.7 45 1.9 8.3 11.9 16.4 24.6 24.2 38 7.6 13.1 14.5 26.4 20.8 39.8-6.3 13.4-13.2 26.8-20.7 39.9zm32.3-13c5.4 13.4 10 26.8 13.8 39.8-13.1 3.2-26.9 5.9-41.2 8 4.9-7.7 9.8-15.6 14.4-23.7 4.6-8 8.9-16.1 13-24.1zm-101.4 106.7c-9.3-9.6-18.6-20.3-27.8-32 9 .4 18.2.7 27.5.7 9.4 0 18.7-.2 27.8-.7-9 11.7-18.3 22.4-27.5 32zm-74.4-58.9c-14.2-2.1-27.9-4.7-41-7.9 3.7-12.9 8.3-26.2 13.5-39.5 4.1 8 8.4 16 13.1 24s9.5 15.8 14.4 23.4zm73.9-208.1c9.3 9.6 18.6 20.3 27.8 32-9-.4-18.2-.7-27.5-.7-9.4 0-18.7.2-27.8.7 9-11.7 18.3-22.4 27.5-32zm-74 58.9c-4.9 7.7-9.8 15.6-14.4 23.7-4.6 8-8.9 16-13 24-5.4-13.4-10-26.8-13.8-39.8 13.1-3.1 26.9-5.8 41.2-7.9zm-90.5 125.2c-35.4-15.1-58.3-34.9-58.3-50.6s22.9-35.6 58.3-50.6c8.6-3.7 18-7 27.7-10.1 5.7 19.6 13.2 40 22.5 60.9-9.2 20.8-16.6 41.1-22.2 60.6-9.9-3.1-19.3-6.5-28-10.2zm53.8 142.9c-13.6-7.8-19.5-37.5-14.9-75.7 1.1-9.4 2.9-19.3 5.1-29.4 19.6 4.8 41 8.5 63.5 10.9 13.5 18.5 27.5 35.3 41.6 50-32.6 30.3-63.2 46.9-84 46.9-4.5-.1-8.3-1-11.3-2.7zm237.2-76.2c4.7 38.2-1.1 67.9-14.6 75.8-3 1.8-6.9 2.6-11.5 2.6-20.7 0-51.4-16.5-84-46.6 14-14.7 28-31.4 41.3-49.9 22.6-2.4 44-6.1 63.6-11 2.3 10.1 4.1 19.8 5.2 29.1zm38.5-66.7c-8.6 3.7-18 7-27.7 10.1-5.7-19.6-13.2-40-22.5-60.9 9.2-20.8 16.6-41.1 22.2-60.6 9.9 3.1 19.3 6.5 28.1 10.2 35.4 15.1 58.3 34.9 58.3 50.6-.1 15.7-23 35.6-58.4 50.6z"/>
                <circle cx="420.9" cy="296.5" r="45.7"/>
              </g>
            </svg>
          </div>
          <div>
            <img
              src={process.env.PUBLIC_URL + "/images/livechat/react_logo_150x50.png"}
              alt="Logo React qui tourne" />
          </div>
        </div>
        <div className="col_flex_aro">
          <p className="pageText" style={{paddingRight: '30px'}}>
            <span style={{marginLeft:'30px'}}></span>Lorsqu'un utilisateur se sert d'une application web, 
            il est  heureux de pouvoir trouver une assistance rapide et professionnelle. Pour cela le 
            LiveChat représente un outil d'assistance idéal, il permet aux utilisateurs de pouvoir 
            obtenir directement l'information qu'ils cherchent sans quitter l'application. REACTjs n'est 
            pas la seule librairie capable de gérer efficacement le web dynamique, c'est la librairie 
            que j'ai choisie pour sa simplicité d'utilisation.
          </p>
        </div>
      </div>
        <div className="">
          <p className="pageText pageText_2" style={{paddingTop: '5px', paddingBottom: '5px'}}>
            <span style={{marginLeft:'30px'}}></span>Ce livechat est une base qui peut être 
            agrémentée de plusieurs fonctionnalités. On pourrait ajouter la possibilité d'échanger 
            des fichiers et des screenshoots, ajouter l'utilisation de smileys et bien d'autres options. 
            Vous pouvez tester ce modèle de livechat aux adresses ci-dessous : 
          </p>
          <ul className="col_flex_aro">
            <li className="row_flex_aro pageText" style={{margin: '10px 0'}}>
              Interface utilisateur : &nbsp;
              <a
                href="https://pascalcosta.fr/livechatDemo"
                target="_blank"
                rel="noreferrer">livechatDemo</a>
            </li>
            <li className="row_flex_aro pageText" style={{margin: '10px 0'}}>
              Interface utilisateur : &nbsp;
              <a
                href="https://pascalcosta.fr/livechatAdmin"
                target="_blank"
                rel="noreferrer">livechatAdmin</a>
            </li>
            <li className="row_flex_aro pageText" style={{margin: '10px 0'}}>
              <a
                href="https://github.com/PasccalFullStack/liveChatDemo"
                target="_blank"
                rel="noreferrer">Dépôt GIT partie utilisateur</a>
            </li>
          </ul>
          <p className="pageText">
            <span style={{marginLeft:'30px'}}></span>Choisissez le même pseudo pour les deux interfaces, 
            ceci vous évite de vous identifier. Vous pouvez ensuite choisir entre 4 comptes utilsateurs 
            et 4 comptes opérateurs prédéfinis.
          </p>
        </div>
        <div className="row_flex_aro" id="pourquoiunlivechat" style={{marginTop: '40px'}}>
          <h2 className="lvH2Title">Organisation du code</h2>
        </div>
        <div className="col_flex_aro">
          <p className="pageText" style={{paddingRight: '30px'}}>
            <span style={{marginLeft:'30px'}}></span>A chacun sa façon de s'organiser, pour ma part, 
            j'apprécie avoir à disposition un logigramme de l'organisation de mes composants REACT 
            comme ci-dessous. Lorsque je modifie un composant ou une requête, je peux ainsi d'un 
            rapide coup d'oeuil me remémorer les parents et enfants qui seront influencés par ma 
            modification. Même pour un code de taille modéré, ce principe reste intéressant.
          </p>
        </div>
        <div className="row_flex_aro">
          <img
            className="logigramme_img"
            src={process.env.PUBLIC_URL + 'images/livechat/logigramme.png'}
            alt="under construction" />
        </div>
        <div className={window.screen.width > 550 ? "row_flex_aro" : "col_flex_aro"}>
          <img
            className="folder_img"
            src={process.env.PUBLIC_URL + 'images/livechat/livechat_img8_310x418.png'}
            alt="under construction" />
          <div className="col_flex_aro">
            <p className="pageText" style={{paddingRight: '30px'}}>
              <span style={{marginLeft:'30px'}}></span>En ce qui concerne l'organisation des fichiers, 
              les composants <code>Header</code> et <code>Carousel</code> ne sont pas pleinement concernés 
              par le fonctionnement du livechat, je les ai donc laissés au premier niveau de 
              <code>./component</code>. Ensuite, les composants propres au livechat sont rassemblés dans 
              <code>./component/livechat/</code> qui  contient 3 sous-dossiers : <code>/liveChatStyle/</code> 
              pour le style CSS, les fonctions et le reducer sont contenus dans <code>liveChatFunction</code> et les requêtes 
              sont dans un dossier <code>/liveChatRequest/</code>
            </p>
          </div>
        </div>
        <div className="row_flex_aro" id="pourquoiunlivechat" style={{marginTop: '40px'}}>
          <h2 className="lvH2Title">Organisation des requêtes</h2>
        </div>
        <div className="col_flex_aro">
          <p className="pageText" style={{paddingRight: '30px'}}>
            <span style={{marginLeft:'30px'}}></span>Les requêtes sont gérées par Axios. Les données constantes 
            de requête sont donc insérées dans l'instance Axios, fichier : <code>liveChatAxiosInst.js</code>.
          </p>
          <h3>Instance Axios</h3>
          <p className="pageTextCode">
            <code>import axios from 'axios';</code><br></br><br></br>
            <code>{'const axios_instance  = axios.create({'}</code><br></br>
            <code style={{marginLeft: '40px'}}>baseURL: process.env.REACT_APP_LIVE_CHAT_API,</code><br></br>
            <code style={{marginLeft: '40px'}}>timeout: 1000,</code><br></br>
            <code style={{marginLeft: '40px'}}>{'headers: {'}</code><br></br>
            <code style={{marginLeft: '80px'}}>'Content-Type': 'application/json',</code><br></br>
            <code style={{marginLeft: '80px'}}>'Authorization': 'Bearer ' + process.env.REACT_APP_ACCESS_TOKEN,</code><br></br>
            <code style={{marginLeft: '40px'}}>{'  },'}</code><br></br>
            <code>{'});'}</code><br></br>
            <code>export default axios_instance;</code><br></br>
          </p>
        </div>
        <div className="col_flex_aro">
          <h3>Exemple de requête</h3>
          <p className="pageTextCode">
            <code>import axios_instance from './liveChatAxiosInst.js';</code><br></br><br></br>
            <code>{'async function getUsers(dispatch) {'}</code><br></br>
            <code style={{marginLeft: '40px'}}>await axios_instance.post('',</code><br></br>
            <code style={{marginLeft: '80px'}}>{'{'}</code><br></br>
            <code style={{marginLeft: '120px'}}>action: 'getUsers'</code><br></br>
            <code style={{marginLeft: '80px'}}>{'},'}</code><br></br>
            <code style={{marginLeft: '40px'}}> )</code><br></br>
            <code style={{marginLeft: '40px'}}>{'.then((resp) => {'}</code><br></br>
            <code style={{marginLeft: '80px'}}>{'if (resp.status === 200) {'}</code><br></br>
            <code style={{marginLeft: '120px'}}>{'dispatch({'}</code><br></br>
            <code style={{marginLeft: '160px'}}>type: 'change_user_list',</code><br></br>
            <code style={{marginLeft: '160px'}}>{'payload: {user_list: resp.data.userList},'}</code><br></br>
            <code style={{marginLeft: '120px'}}>{'});'}</code><br></br>
            <code style={{marginLeft: '80px'}}>{'} else {'}</code><br></br>
            <code style={{marginLeft: '120px'}}>{'dispatch({'}</code><br></br>
            <code style={{marginLeft: '160px'}}>type: 'change_user_list',</code><br></br>
            <code style={{marginLeft: '160px'}}>{'payload: {user_list: []},'}</code><br></br>
            <code style={{marginLeft: '120px'}}>{'});'}</code><br></br>
            <code style={{marginLeft: '80px'}}>{'}'}</code><br></br>
            <code style={{marginLeft: '40px'}}>{'})'}</code><br></br>
            <code style={{marginLeft: '40px'}}>{'.catch(() => dispatch({'}</code><br></br>
            <code style={{marginLeft: '80px'}}>type: 'change_user_list',</code><br></br>
            <code style={{marginLeft: '80px'}}>{'payload: {user_list: []},'}</code><br></br>
            <code style={{marginLeft: '40px'}}>{'}))'}</code><br></br>
            <code style={{marginLeft: '0'}}>{'}'}</code><br></br>
            <code>export default getUsers;</code>
          </p>
        </div>
        <div className="row_flex_aro" id="pourquoiunlivechat" style={{marginTop: '40px'}}>
          <h2 className="lvH2Title">Gestion du state avec un reducer</h2>
        </div>
        <div className="col_flex_aro">
          <p className="pageText" style={{paddingRight: '30px'}}>
            <span style={{marginLeft:'30px'}}></span>On peut gérer les actions d'un reducer de deux façons,
            soit avec les "<code>if else</code>" ou avec un "<code>switch case</code>". Dans les deux cas, 
            le résultat est le même, je préfère le "<code>if else</code>" car un peu moins verbeux. Si on utilise 
            un livechat avec beaucoup plus d'interlocuteurs (utilisateurs et opérateurs), on aurait certainemment 
            besoin de gérer le state avec Redux ou mieux, Redux ToolKit qui est plus simple et rapide à mettre en 
            &oelig;uvre.<br></br><br></br>
            Ci-dessous un exemple de changement d'état lorsqu'on change d'utilisateur :
          </p>
        </div>
        <p className="pageTextCode">
          <code>{'const liveChatReducer = (state, action) => {'}</code><br></br>
          <code style={{marginLeft: '40px'}}>{"if (action.type === 'change_active_user') {"}</code><br></br>
          <code style={{marginLeft: '80px'}}>{'return {'}</code><br></br>
          <code style={{marginLeft: '120px'}}>...state,</code><br></br>
          <code style={{marginLeft: '120px'}}>active_user_display: action.payload.active_user_display,</code><br></br>
          <code style={{marginLeft: '120px'}}>active_user_id: action.payload.active_user_id,</code><br></br>
          <code style={{marginLeft: '120px'}}>active_user_pseudo: action.payload.active_user_pseudo,</code><br></br>
          <code style={{marginLeft: '120px'}}>active_user_username: action.payload.active_user_username,</code><br></br>
          <code style={{marginLeft: '80px'}}>{'};'}</code><br></br>
          <code style={{marginLeft: '40px'}}>{'}'}</code><br></br>
          <code style={{marginLeft: '40px'}}>throw Error('Unknown action.');</code><br></br>
          <code>{'}'}</code><br></br>
          <code>export default liveChatReducer;</code><br></br>
        </p>
          <br></br>
          <br></br>
          <br></br>
          <br></br>
    </section>
  )
}
